// extracted by mini-css-extract-plugin
module.exports = {"footer":"performance_footer__Ex5v8","footer__mosh":"performance_footer__mosh___Z2gi","footer__menu":"performance_footer__menu__mRzuB","topbar":"performance_topbar__W7AF8"};